export default __webpack_public_path__ + "static/media/eq-premium.7a3527df.png";